import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cash Remove"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cash-remove',
    templateUrl: './icon-cash-remove.component.html',
    styleUrls: ['./icon-cash-remove.component.scss'],
    standalone: false
})
export class IconCashRemoveComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
